import { render, staticRenderFns } from "./platformConfig.vue?vue&type=template&id=1b45eeba&scoped=true&"
import script from "./platformConfig.vue?vue&type=script&lang=js&"
export * from "./platformConfig.vue?vue&type=script&lang=js&"
import style0 from "./platformConfig.vue?vue&type=style&index=0&id=1b45eeba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b45eeba",
  null
  
)

export default component.exports